import { Plugins } from "@capacitor/core";
const { LocalNotifications } = Plugins;
import { FCM } from "@capacitor-community/fcm";
import { PushNotifications } from "@capacitor/push-notifications";
import router from "@/router/index";

async function fcmSetting() {
  console.log("FCM 세팅");
  await PushNotifications.requestPermissions()
    .then((value) => {
      console.log("권한 확인", value);
      if (value.receive == "granted") {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          PushNotifications.register().then((res) => {
            console.log("From Regisiter Promise", res);
          });
          PushNotifications.addListener("registration", (token) => {
            console.log(token);
            FCM.getToken()
              .then((result) => {
                console.log("fcm token", result.token);
                localStorage.setItem("fcmtoken", result.token);
              })
              .catch((err) => console.log("i am Error", err));
          });
        } else {
          FCM.getToken()
            .then((result) => {
              // this.remoteToken = result.token;
              console.log("remote token", result);
              // localStorage.setItem("fcmtoken",result.token);
            })
            .catch((err) => console.log("i am Error", err));
        }
      }
    })
    .catch((reason) => {
      console.log("request permision catch", reason);
    });

  if (/Android/i.test(navigator.userAgent)) {
    // 안드로이드
    PushNotifications.addListener("registration", (token) => {
      console.log("android fcm token", token.value);
      localStorage.setItem("fcmtoken", token.value);
    });

    PushNotifications.addListener("registrationError", (error) => {
      alert("Error on registration: " + JSON.stringify(error));
    });
  } else {
    PushNotifications.addListener("registration", (token) => {
      console.log("ios fcm token", token.value);
      localStorage.setItem("fcmtoken", token.value);
    });

    PushNotifications.addListener("registrationError", (error) => {
      alert("Error on registration: " + JSON.stringify(error));
    });
  }

  PushNotifications.addListener("pushNotificationReceived", async (notification) => {
    console.log("received");
    console.log(notification);
    sendNotification(notification);
  });
}

async function receivedNotifcation() {
  PushNotifications.addListener("pushNotificationActionPerformed", async (notification) => {
    router.push({ path: "/coaching_message" });
  });
}

async function sendNotification(data) {
  console.log("sendNotification", data);
  let bodyText = data.body.replace(/(<([^>]+)>)/gi, "");
  const notifs = await LocalNotifications.schedule({
    notifications: [
      {
        title: data.title,
        body: bodyText,
        id: 1,
        schedule: { at: new Date(Date.now() + 100) },
        sound: null,
        attachments: null,
        actionTypeId: "",
        extra: null,
        foreground: false,
      },
    ],
  });

  await LocalNotifications.addListener("localNotificationActionPerformed", async (notification) => {
    const data = notification.notification.data;
    console.log("localNotificationActionPerformed: " + JSON.stringify(data));
    router.push({ path: "/coaching_message" });
  });

  console.log("scheduled notifications", notifs);
}

export { fcmSetting, sendNotification, receivedNotifcation };
